module.exports = __webpack_public_path__ + "static/media/icn-delete-blue.db9c263a.svg";